(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pl-helix-components"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pl-helix-carousel')) {
 class PlHelixRail extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController();
   this.track = this.querySelector('[data-plhx-track]');
   this.controls = this.querySelector('[data-plhx-controls]');
   if (!this.track) return;
   this.prev = this.querySelector('[data-plhx-prev]');
   this.next = this.querySelector('[data-plhx-next]');
   this.progress = this.querySelector('[data-plhx-progress]');
   this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
   const on = (el, type, fn) => el?.addEventListener(type, fn, {signal:this.abort.signal});
   this.on = on;
   on(this.progress,'keydown',event=>{
    if(['ArrowRight','ArrowUp','ArrowLeft','ArrowDown','Home','End'].includes(event.key)) {
     event.preventDefault();this.stop?.();
     if(event.key==='Home'||event.key==='End') {const items=this.track.children;this.go(items[event.key==='Home'?0:items.length-1]);}
     else this.move(event.key==='ArrowRight'||event.key==='ArrowUp'?1:-1,true);
    }
   });
   on(this.progress,'pointerdown',()=>{this.scrubbing=true;this.stop?.();});
   on(window,'pointerup',()=>{if(this.scrubbing){this.scrubbing=false;this.track.style.scrollSnapType='';this.update();}});
   on(this.progress,'input',()=>{
    this.stop?.();
    this.track.style.scrollSnapType='none';
    this.track.scrollLeft=Number(this.progress.value)/1000*(this.track.scrollWidth-this.track.clientWidth);
   });
   on(this.progress,'change',()=>{this.scrubbing=false;this.track.style.scrollSnapType='';this.update();});
   on(this.progress,'pointercancel',()=>{this.scrubbing=false;this.track.style.scrollSnapType='';this.update();});
   on(this.prev,'click',()=>this.move(-1,true));
   on(this.next,'click',()=>this.move(1,true));
   on(this.track,'scroll',()=>this.update());
   on(this.track,'keydown',event=>{
    if(event.target!==this.track) return;
    if(event.key==='ArrowRight'||event.key==='ArrowLeft') {event.preventDefault();this.move(event.key==='ArrowRight'?1:-1,true);}
   });
   on(this,'shopify:block:select',event=>{
    this.stop?.();
    const child=Array.from(this.track.children).find(item=>item.dataset.blockId===event.detail.blockId);
    if(child) this.go(child,false);
   });
   this.observer = new ResizeObserver(()=>this.update());
   this.observer.observe(this.track);
   this.update();
  }
  nearest() {
   const start=this.track.getBoundingClientRect().left;
   return Array.from(this.track.children).reduce((best,child,index,all)=>Math.abs(child.getBoundingClientRect().left-start)<Math.abs(all[best].getBoundingClientRect().left-start)?index:best,0);
  }
  go(child,smooth=true) {
   const padding=parseFloat(getComputedStyle(this.track).paddingLeft)||0;
   this.track.scrollBy({left:child.getBoundingClientRect().left-this.track.getBoundingClientRect().left-padding,behavior:smooth&&!this.reduced.matches?'smooth':'instant'});
  }
  move(delta) {
   const children=Array.from(this.track.children);
   const target=Math.max(0,Math.min(children.length-1,this.nearest()+delta));
   if(children[target]) this.go(children[target]);
  }
  update() {
   const overflow=this.track.scrollWidth>this.track.clientWidth+4;
   if(this.controls) this.controls.hidden=!overflow;
   if(this.progress) {
    const max=this.track.scrollWidth-this.track.clientWidth;
    if(!this.scrubbing)this.progress.value=max>0?Math.round(this.track.scrollLeft/max*1000):0;
    this.controls.style.setProperty('--plhx-thumb',`${Math.max(5,this.track.clientWidth/Math.max(1,this.track.scrollWidth)*100)}%`);
    this.progress.setAttribute('aria-valuetext',`${Math.round(Number(this.progress.value)/10)}%`);
   }
   if(this.prev) this.prev.disabled=this.track.scrollLeft<=4;
   if(this.next) this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-4;
   if(this.dataset.layout==='grid') {this.track.removeAttribute('tabindex');if(this.controls)this.controls.hidden=true;}
  }
  disconnectedCallback() {this.abort?.abort();this.observer?.disconnect();}
 }
 class PlHelixCarousel extends PlHelixRail {
  connectedCallback() {
   super.connectedCallback();
   this.paused=false;
   this.pause=this.querySelector('[data-plhx-pause]');
   this.status=this.querySelector('[data-plhx-status]');
   this.on(this.pause,'click',()=>{this.paused=!this.paused;this.syncPause();this.schedule();});
   this.on(this,'focusin',event=>{if(event.target!==this.pause)this.stop();});
   this.on(this.track,'pointerdown',()=>this.stop());
   this.on(this,'mouseenter',()=>{this.hovered=true;this.schedule();});
   this.on(this,'mouseleave',()=>{this.hovered=false;this.schedule();});
   this.on(document,'visibilitychange',()=>this.schedule());
   this.on(this.reduced,'change',()=>this.schedule());
   this.schedule();
  }
  stop() {this.paused=true;this.syncPause();this.schedule();}
  syncPause() {this.pause?.setAttribute('aria-pressed',String(this.paused));}
  schedule() {
   clearTimeout(this.timer);
   if(this.dataset.autoplay!=='true'||this.paused||this.hovered||this.reduced.matches||document.hidden||this.track.children.length<2||window.Shopify?.designMode) return;
   this.timer=setTimeout(()=>{this.move(1,false);this.schedule();},Number(this.dataset.interval)||7000);
  }
  move(delta,manual=false) {
   if(manual)this.stop();
   const children=Array.from(this.track.children);
   const target=(this.nearest()+delta+children.length)%children.length;
   if(children[target]) {this.go(children[target]);if(manual&&this.status)this.status.textContent=children[target].getAttribute('aria-label');}
  }
  update() {
   super.update();
   if(this.prev)this.prev.disabled=false;
   if(this.next)this.next.disabled=false;
   const count=this.querySelector('[data-plhx-count]');
   if(count)count.textContent=`${this.nearest()+1} / ${this.track.children.length}`;
  }
  disconnectedCallback() {super.disconnectedCallback();clearTimeout(this.timer);}
 }
 class PlHelixMarquee extends HTMLElement {
  connectedCallback() {
   this.abort=new AbortController();
   this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
   this.paused=false;
   const toggle=()=>{this.paused=!this.paused;this.setAttribute('aria-pressed',String(this.paused));this.sync();};
   this.addEventListener('click',toggle,{signal:this.abort.signal});
   this.addEventListener('keydown',event=>{if(event.key===' '||event.key==='Enter'){event.preventDefault();toggle();}},{signal:this.abort.signal});
   this.reduced.addEventListener('change',()=>this.sync(),{signal:this.abort.signal});
   this.addEventListener('mouseenter',()=>{this.hovered=true;this.sync();},{signal:this.abort.signal});
   this.addEventListener('mouseleave',()=>{this.hovered=false;this.sync();},{signal:this.abort.signal});
   this.sync();
  }
  sync() {this.dataset.running=String(!this.paused&&!this.hovered&&!this.reduced.matches);}
  disconnectedCallback() {this.abort?.abort();}
 }
 customElements.define('pl-helix-rail',PlHelixRail);
 customElements.define('pl-helix-carousel',PlHelixCarousel);
 customElements.define('pl-helix-marquee',PlHelixMarquee);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pl-low-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pl-low-stock')) {
    customElements.define('pl-low-stock', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('[data-section-type]') || this.closest('[data-quick-add-modal]');
        this.message = this.querySelector('[data-low-stock-message]');
        const values = this.querySelector('[data-low-stock-values]');
        if (!this.scope || !this.message || !values) return;
        this.messages = new Map(Array.from(values.content.querySelectorAll('[data-variant-id]'), item => [item.dataset.variantId, item.textContent]));
        this.onVariantChange = event => {
          const variant = event.detail?.variant;
          const text = variant?.available ? this.messages.get(String(variant.id)) || '' : '';
          this.message.textContent = text;
          this.message.hidden = !text;
        };
        this.scope.addEventListener('theme:variant:change', this.onVariantChange);
      }
      disconnectedCallback() {
        this.scope?.removeEventListener('theme:variant:change', this.onVariantChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
